import React from 'react';
import PageBanner from '../components/PageBanner';
import AboutSection from '../components/AboutSection';
import StatsSection from '../components/StatsSection';
import VisionTabs from '../components/VisionTabs';
import WaysToTransform from '../components/WaysToTransform';
import CTASection from '../components/CTASection';
import { Award, Users, Target, Sparkles } from 'lucide-react';

const VALUES = [
  { icon: Sparkles, title: 'Dynamic', desc: 'Adapting continuously to the evolving needs of communities we serve.' },
  { icon: Award, title: 'Passionate', desc: 'Driven by deep love for empowering the next generation of leaders.' },
  { icon: Users, title: 'Committed', desc: 'Steadfast in our promise to bridge the gender gap in education.' },
  { icon: Target, title: 'Goal-Oriented', desc: 'Measuring impact through tangible outcomes and lasting change.' },
];

const About = () => (
  <main>
    <PageBanner title="About Us" crumb="About" />
    <AboutSection />
    <StatsSection />
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">What guides us</p>
          <h2 className="heading-display text-4xl md:text-5xl font-bold text-slate-900">Our Core Values</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {VALUES.map((v, i) => (
            <div key={i} className="bg-slate-50 rounded-sm p-8 text-center card-lift">
              <div className="w-16 h-16 mx-auto bg-[#F97559] text-white rounded-full grid place-items-center">
                <v.icon size={26} />
              </div>
              <h3 className="heading-display mt-5 text-xl font-bold text-slate-900">{v.title}</h3>
              <p className="mt-3 text-slate-600 text-sm leading-7">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <VisionTabs />
    <WaysToTransform />
    <CTASection />
  </main>
);

export default About;
